export const REQUIRE_RESET_PASSWORD_SERVICE = 'requireResetPasswordService';

    export class RequireResetPasswordService {
        static $inject = ["$http", "$q"];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService) { }

        resetPassword(email: string) {
            return this.$http.get<string>(`api/requireresetpassword/requireresetpassword`, { params: { email: email } }).then(
                null,
                reason => {
                    return this.$q.reject(reason.data.message);
                });
        }
    }

   


// WEBPACK FOOTER //
// ./app/require-reset-password/require-reset-password.service.ts